import { InvokeCommand } from "@aws-sdk/client-lambda";
import lambdaClient from "./lambda-client";
import { DirectInvocationRequest, DirectInvocationResponse } from "@/types";

const LAMBDA_FUNCTION_NAME = process.env.SCAN_URL_LAMBDA_NAME || "dev-commercial-api-go";

export async function scanUrl(
  url: string,
  action?: "scan_url" | "screenshot",
  options?: {
    lang?: string;
    ignoredDbCache?: boolean;
    ignoredAi?: boolean;
    turnstileToken?: string;
    clientIp?: string;
  }
): Promise<DirectInvocationResponse> {
  const request: DirectInvocationRequest = {
    action: action || "scan_url",
    url,
    lang: options?.lang || "vi",
    ignored_db_cache: options?.ignoredDbCache ?? false,
    ignored_ai: options?.ignoredAi ?? false,
    turnstile_token: options?.turnstileToken,
    client_ip: options?.clientIp,
    source: "trustops",
  };

  console.log("Invoking Lambda with request:", request);

  const payload = Buffer.from(JSON.stringify(request));

  try {
    const command = new InvokeCommand({
      FunctionName: LAMBDA_FUNCTION_NAME,
      InvocationType: "RequestResponse",
      Payload: payload,
    });

    const response = await lambdaClient.send(command);

    if (response.FunctionError) {
      console.error("Lambda function error:", response.FunctionError);
      return {
        success: false,
        error: response.FunctionError,
      };
    }

    if (!response.Payload) {
      return {
        success: false,
        error: "No payload in Lambda response",
      };
    }

    const result: DirectInvocationResponse = JSON.parse(
      Buffer.from(response.Payload).toString("utf-8")
    );

    return result;
  } catch (error) {
    console.error("Failed to invoke Lambda:", error);
    return {
      success: false,
      error: error instanceof Error ? error.message : "Unknown error",
    };
  }
}
